import Home from '../views/Home.vue'
export default {
  path: '/statistics',
  name: '装备统计',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: false,
  children: [
    {
      path: '/statistics',
      component: () =>
                import('../views/statistics/index'),
      name: '装备统计',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/statistics/count',
      component: () =>
                import('../views/statistics/details/count/index'),
      name: '装备统计详情',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/statistics/declare',
      component: () =>
                import('../views/statistics/details/declare/index'),
      name: '装备申报',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
